import messages from "./messages";
import { sectionItem, docItem, calendarPanel, mainContentItem } from "./types";

const apiUrl = (process.env.REACT_APP_API_URL || "http://basf-new.app.test/backend/api") + "/Help";

export const helpPageSections: sectionItem[] = [
  {
    id: "dataUpdateCalendar",
    name: messages.dataUpdateCalendarName,
    level: 0,
    showMenu: false,
  },
  {
    id: "BackgroundInformationOnSources",
    name: messages.BackgroundInformationOnSourcesName,
    level: 0,
    showMenu: true,
  },
  {
    id: "Crops",
    name: messages.Crops,
    level: 1,
    showMenu: true,
  },
  {
    id: "APOfficialCropsDataset",
    name: messages.APOfficialCropsDataset,
    level: 2,
    showMenu: true,
  },
  {
    id: "USDA",
    name: messages.USDA,
    level: 2,
    showMenu: true,
  },
  {
    id: "UNFAO",
    name: messages.UNFAO,
    level: 2,
    showMenu: true,
  },
  {
    id: "FAO",
    name: messages.FAO,
    level: 2,
    showMenu: true,
  },
  {
    id: "FAPRI",
    name: messages.FAPRI,
    level: 2,
    showMenu: true,
  },
  {
    id: "USDACrop",
    name: messages.USDACrop,
    level: 2,
    showMenu: true,
  },
  {
    id: "DailyNASDAQ",
    name: messages.DailyNASDAQ,
    level: 2,
    showMenu: true,
  },
  {
    id: "Prices",
    name: messages.Prices,
    level: 1,
    showMenu: true,
  },
  {
    id: "APPrices",
    name: messages.APPrices,
    level: 2,
    showMenu: true,
  },
  {
    id: "APForecast",
    name: messages.APForecast,
    level: 2,
    showMenu: true,
  },
  {
    id: "AlternativePrice",
    name: messages.AlternativePrice,
    level: 2,
    showMenu: true,
  },
  {
    id: "Trade",
    name: messages.Trade,
    level: 1,
    showMenu: true,
  },
  {
    id: "APTrade",
    name: messages.APTrade,
    level: 2,
    showMenu: true,
  },
  {
    id: "Macroeconomy",
    name: messages.Macroeconomy,
    level: 1,
    showMenu: true,
  },
  {
    id: "SpecialTopics",
    name: messages.SpecialTopicsFullHeader,
    level: 1,
    showMenu: true,
  },
];

export const helpPageDocs: docItem[] = [
  {
    id: "definitionOfSourcesForAPOfficial",
    name: messages.definitionOfSourcesForAPOfficialName,
    description: messages.definitionOfSourcesForAPOfficialDescription,
    download: `${apiUrl}/DefinitionOfSources`,
    extension: ".xlsx",
  },
  {
    id: "DataAvailabilityOfAPOfficialHarmonizedDataset",
    name: messages.DataAvailabilityOfAPOfficialHarmonizedDatasetName,
    description: messages.DataAvailabilityOfAPOfficialHarmonizedDatasetDescription,
    download: `${apiUrl}/DataAvailability`,
    extension: ".xlsx",
  },
  {
    id: "UserGuide",
    name: messages.UserGuideName,
    description: messages.UserGuideDescription,
    download: `${apiUrl}/UserGuide`,
    extension: ".pdf",
  },
  {
    id: "DefinitionsAndFormulas",
    name: messages.FormulasName,
    description: messages.FormulasDescription,
    download: `${apiUrl}/Formulas`,
    extension: ".xlsx",
  },
  {
    id: "AgTerminalIntro",
    name: messages.IntroName,
    download: `${apiUrl}/Introduction`,
    extension: ".pptx",
  },
  {
    id: "GlobalSlidesDescription",
    name: messages.GlobalSlidesName,
    description: messages.GlobalSlidesDescription,
    download: `${apiUrl}/GlobalSlidesDescription`,
    extension: ".pptx",
  },
  {
    id: "APESlidesDescription",
    name: messages.APESlidesName,
    description: messages.APESlidesDescription,
    download: `${apiUrl}/APESlidesDescription`,
    extension: ".pptx",
  },
];

export const helpPageCalendar: calendarPanel[] = [
  {
    id: "day",
    title: messages.Daily,
    cards: [
      {
        id: 1,
        title: messages.EveryDay,
        contentItems: [messages.DailyNASDAQ],
      },
    ],
  },
  {
    id: "week",
    title: messages.Weekly,
    cards: [
      {
        id: 1,
        title: messages.Wednesday,
        contentItems: [
          messages.FAOCommodityPrices,
          messages.ICEEURONEXT,
          messages.DAX,
          messages.Gold,
          messages.NYSE,
          messages.CFTC,
          messages.IGC,
        ],
      },
      {
        id: 2,
        title: messages.Friday,
        contentItems: [messages.EIAOil],
      },
    ],
  },
  {
    id: "month",
    title: messages.Monthly,
    cards: [
      {
        id: 1,
        title: messages.By15month,
        contentItems: [messages.USDAAgrPrices, messages.Fertilizer, messages.IMFprices, messages.UNCOMTRADE, messages.USDAPSD],
      },
    ],
  },
  {
    id: "quarter",
    title: messages.Quarterly,
    cards: [
      {
        id: 1,
        title: messages.By7Month,
        contentItems: [messages.WorldBankFP],
      },
      {
        id: 2,
        title: messages.By10month,
        contentItems: [messages.Slide23],
      },
      {
        id: 3,
        title: messages.By25month,
        contentItems: [messages.GlobalIP],
      },
    ],
  },
  {
    id: "biannual",
    title: messages.Biannual,
    cards: [
      {
        id: 1,
        title: messages.AprOct,
        contentItems: [messages.FAOProdSTAT],
      },
    ],
  },
  {
    id: "annual",
    title: messages.Annual,
    cards: [
      {
        id: 1,
        title: messages.Feb,
        contentItems: [messages.USDAProjP, messages.FAOFB, messages.EUROSTAT, messages.USDAERS],
      },
      {
        id: 2,
        title: messages.Apr,
        contentItems: [messages.FAPRIcrops, messages.GlobalIC],
      },
      {
        id: 3,
        title: messages.May,
        contentItems: [messages.USDAFC],
      },
      {
        id: 4,
        title: messages.Jul,
        contentItems: [messages.USDAComP, messages.FAOPop],
      },
      {
        id: 5,
        title: messages.Aug,
        contentItems: [messages.OECDFAOCrops, messages.FAPRI2015],
      },
      {
        id: 6,
        title: messages.Sep,
        contentItems: [messages.OECDFAOPrices, messages.FAOProdPrices],
      },
    ],
  },
  {
    id: "biennial",
    title: messages.Biennial,
    cards: [
      {
        id: 1,
        title: messages.Jun,
        contentItems: [messages.FAOTradeSTAT],
      },
    ],
  },
];

export const helpPageMainContent: mainContentItem[] = [
  {
    id: "Crops",
    name: messages.Crops,
    sections: [
      {
        id: "APOfficialCropsDataset",
        name: messages.APOfficialCropsDataset,
        subsections: [
          {
            id: "Crops1",
            name: messages.Overview,
            paragraphs: [
              {
                id: "Crops11",
                type: "text",
                content: messages.APOfficialCropsDatasetOverviewP1,
              },
              {
                id: "Crops12",
                type: "text",
                content: messages.APOfficialCropsDatasetOverviewP2,
              },
              {
                id: "Crops13",
                type: "text",
                content: messages.APOfficialCropsDatasetOverviewP3,
              },
              {
                id: "Crops14",
                type: "text",
                content: messages.APOfficialCropsDatasetOverviewP4,
              },
              {
                id: "Crops15",
                type: "list",
                content: [
                  messages.APOfficialCropsDatasetOverviewLi1,
                  messages.APOfficialCropsDatasetOverviewLi2,
                  messages.APOfficialCropsDatasetOverviewLi3,
                  messages.APOfficialCropsDatasetOverviewLi4,
                ],
              },
            ],
          },
          {
            id: "Crops2",
            name: messages.DatasetStructure,
            paragraphs: [
              {
                id: "Crops21",
                type: "text",
                content: messages.APOfficialCropsDatasetDatasetStructureP1,
              },
              {
                id: "Crops22",
                type: "text",
                content: messages.APOfficialCropsDatasetDatasetStructureP2,
              },
              {
                id: "Crops23",
                type: "download",
                content: {
                  path: "/help-files/definition_of_sources_for_ap_official_crops_dataset.xlsx",
                  text: "Definition of sources for AP official crops dataset.xlsx",
                },
              },
            ],
          },
          {
            id: "Crops3",
            name: messages.UpdateSchedule,
            paragraphs: [
              {
                id: "Crops31",
                type: "text",
                content: messages.APOfficialCropsDatasetUpdateScheduleP1,
              },
              {
                id: "Crops32",
                type: "text",
                content: messages.APOfficialCropsDatasetUpdateScheduleP2,
              },
              {
                id: "Crops33",
                type: "download",
                content: {
                  path: "/help-files/data_availability_of_ap_official_crops_dataset.xlsx",
                  text: "Data Availability of AP official crops dataset.xlsx",
                },
              },
            ],
          },
        ],
      },
      {
        id: "USDA",
        name: messages.USDAFullHeader,
        subsections: [
          {
            id: "USDA1",
            name: null,
            paragraphs: [
              {
                id: "USDA11",
                type: "link",
                content: {
                  path: "http://www.fas.usda.gov/psdonline/",
                  text: "http://www.fas.usda.gov/psdonline/",
                },
              },
            ],
          },
          {
            id: "USDA2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "USDA21",
                type: "text",
                content: messages.USDAOverviewP1,
              },
              {
                id: "USDA22",
                type: "text",
                content: messages.USDAOverviewP2,
              },
              {
                id: "USDA23",
                type: "list",
                content: [messages.USDAOverviewLi1, messages.USDAOverviewLi2, messages.USDAOverviewLi3, messages.USDAOverviewLi4],
              },
              {
                id: "USDA24",
                type: "text",
                content: messages.USDAOverviewP3,
              },
            ],
          },
          {
            id: "USDA3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "USDA31",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP1,
              },
              {
                id: "USDA32",
                type: "download",
                content: {
                  path: "/help-files/usda_psd_glossary.xlsx",
                  text: "USDA PSD Glossary.xlsx",
                },
              },
              {
                id: "USDA33",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP2,
              },
              {
                id: "USDA34",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP3,
              },
              {
                id: "USDA35",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP4,
              },
              {
                id: "USDA36",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP5,
              },
              {
                id: "USDA37",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP6,
              },
              {
                id: "USDA38",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP7,
              },
              {
                id: "USDA39",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP8,
              },
              {
                id: "USDA310",
                type: "text",
                content: messages.USDAGlossaryOfAttributesP9,
              },
            ],
          },
          {
            id: "USDA4",
            name: messages.CountryAndCommodityStructure,
            paragraphs: [
              {
                id: "USDA41",
                type: "text",
                content: messages.USDACountryAndCommodityStructureP1,
              },
              {
                id: "USDA42",
                type: "text",
                content: messages.USDACountryAndCommodityStructureP2,
              },
              {
                id: "USDA43",
                type: "download",
                content: {
                  path: "/help-files/usda_psd_data_mappings.xlsx",
                  text: "USDA PSD Data Mappings.xlsx",
                },
              },
            ],
          },
          {
            id: "USDA5",
            name: messages.FormulasName,
            paragraphs: [
              {
                id: "USDA51",
                type: "text",
                content: messages.USDAFormulasP1,
              },
              {
                id: "USDA52",
                type: "download",
                content: {
                  path: "/help-files/formulas_usda_psd.xlsx",
                  text: "Formulas USDA PSD.xlsx",
                },
              },
            ],
          },
          {
            id: "USDA6",
            name: messages.USDAReleaseSchedulefor2014H,
            paragraphs: [
              {
                id: "USDA61",
                type: "table",
                content: {
                  headers: [messages.USDAReleaseSchedulefor2014TC1H, messages.USDAReleaseSchedulefor2014TC2H],
                  rows: [
                    {
                      column1: messages.Jan,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014WorldHorticultureCitrus,
                        ],
                      },
                    },
                    {
                      column1: messages.Feb,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                        ],
                      },
                    },
                    {
                      column1: messages.Mar,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                        ],
                      },
                    },
                    {
                      column1: messages.Apr,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014LivestockAndPoultry,
                        ],
                      },
                    },
                    {
                      column1: messages.May,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014Sugar,
                        ],
                      },
                    },
                    {
                      column1: messages.Jun,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014Coffee,
                        ],
                      },
                    },
                    {
                      column1: messages.Jul,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014Dairy,
                          messages.USDAReleaseSchedulefor2014WorldHorticultureCitrus,
                        ],
                      },
                    },
                    {
                      column1: messages.Aug,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                        ],
                      },
                    },
                    {
                      column1: messages.Sep,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014Raisins,
                        ],
                      },
                    },
                    {
                      column1: messages.Oct,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014LivestockAndPoultry,
                          messages.USDAReleaseSchedulefor2014TreeNuts,
                        ],
                      },
                    },
                    {
                      column1: messages.Nov,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014Sugar,
                        ],
                      },
                    },
                    {
                      column1: messages.Dec,
                      column2: {
                        type: "list",
                        content: [
                          messages.USDAReleaseSchedulefor2014CottonGrainsOilseeds,
                          messages.USDAReleaseSchedulefor2014Cotton,
                          messages.USDAReleaseSchedulefor2014Grains,
                          messages.USDAReleaseSchedulefor2014Oilseeds,
                          messages.USDAReleaseSchedulefor2014WorldProduction,
                          messages.USDAReleaseSchedulefor2014Coffee,
                          messages.USDAReleaseSchedulefor2014Dairy,
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        id: "UNFAO",
        name: messages.UNFAOFullHeader,
        subsections: [
          {
            id: "UNFAO1",
            name: null,
            paragraphs: [
              {
                id: "UNFAO11",
                type: "link",
                content: {
                  path: "http://faostat3.fao.org/faostat-gateway/go/to/home/E",
                  text: "http://faostat3.fao.org/faostat-gateway/go/to/home/E",
                },
              },
            ],
          },
          {
            id: "UNFAO2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "UNFAO21",
                type: "text",
                content: messages.UNFAOOverviewP1,
              },
              {
                id: "UNFAO22",
                type: "text",
                content: messages.UNFAOOverviewP2,
              },
              {
                id: "UNFAO23",
                type: "list",
                content: [messages.UNFAOOverviewLi1, messages.UNFAOOverviewLi2, messages.UNFAOOverviewLi3, messages.UNFAOOverviewLi4],
              },
            ],
          },
          {
            id: "UNFAO3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "UNFAO31",
                type: "text",
                content: messages.UNFAOGlossaryOfAttributesP1,
              },
              {
                id: "UNFAO32",
                type: "download",
                content: {
                  path: "/help-files/fao_glossary.doc",
                  text: "FAO Glossary.doc",
                },
              },
              {
                id: "UNFAO33",
                type: "text",
                content: messages.UNFAOGlossaryOfAttributesP2,
              },
              {
                id: "UNFAO34",
                type: "text",
                content: messages.UNFAOGlossaryOfAttributesP3,
              },
              {
                id: "UNFAO35",
                type: "text",
                content: messages.UNFAOGlossaryOfAttributesP4,
              },
              {
                id: "UNFAO36",
                type: "text",
                content: messages.UNFAOGlossaryOfAttributesP5,
              },
            ],
          },
          {
            id: "UNFAO4",
            name: messages.CountryAndCommodityStructure,
            paragraphs: [
              {
                id: "UNFAO41",
                type: "text",
                content: messages.UNFAOCountryAndCommodityStructureP1,
              },
              {
                id: "UNFAO42",
                type: "download",
                content: {
                  path: "/help-files/fao_data_mappings.xlsx",
                  text: "FAO data Mappings.xlsx",
                },
              },
            ],
          },
          {
            id: "UNFAO5",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "UNFAO51",
                type: "text",
                content: messages.UNFAOReleaseScheduleP1,
              },
              {
                id: "UNFAO52",
                type: "link",
                content: {
                  path: "http://faostat3.fao.org/home/faostatReleaseCalendar.html",
                  text: "http://faostat3.fao.org/home/faostatReleaseCalendar.html",
                },
              },
              {
                id: "UNFAO53",
                type: "text",
                content: messages.UNFAOReleaseScheduleP2,
              },
              {
                id: "UNFAO54",
                type: "link",
                content: {
                  path: "http://faostat3.fao.org/faostat-gateway/go/to/mes/methodology_list/*/E",
                  text: "http://faostat3.fao.org/faostat-gateway/go/to/mes/methodology_list/*/E",
                },
              },
            ],
          },
          {
            id: "UNFAO6",
            name: messages.FormulasName,
            paragraphs: [
              {
                id: "UNFAO61",
                type: "text",
                content: messages.UNFAOFormulasP1,
              },
              {
                id: "UNFAO62",
                type: "download",
                content: {
                  path: "/help-files/formulas_fapri.xlsx",
                  text: "Formulas FAO Prodstat.xlsx",
                },
              },
            ],
          },
        ],
      },
      {
        id: "FAO",
        name: messages.FAOFullHeader,
        subsections: [
          {
            id: "FAO1",
            name: null,
            paragraphs: [
              {
                id: "FAO11",
                type: "link",
                content: {
                  path: "http://www.oecd.org/site/oecd-faoagriculturaloutlook/#d.en.192283",
                  text: "http://www.oecd.org/site/oecd-faoagriculturaloutlook/#d.en.192283",
                },
              },
            ],
          },
          {
            id: "FAO2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "FAO21",
                type: "text",
                content: messages.FAOOverviewP1,
              },
              {
                id: "FAO22",
                type: "text",
                content: messages.FAOOverviewP2,
              },
              {
                id: "FAO23",
                type: "text",
                content: messages.FAOOverviewP3,
              },
              {
                id: "FAO24",
                type: "list",
                content: [messages.FAOOverviewLi1, messages.FAOOverviewLi2, messages.FAOOverviewLi3],
              },
            ],
          },
          {
            id: "FAO3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "FAO31",
                type: "text",
                content: messages.FAOGlossaryOfAttributesP1,
              },
              {
                id: "FAO32",
                type: "download",
                content: {
                  path: "/help-files/fao_oecd_glossary.doc",
                  text: "FAO-OECD Glossary.doc",
                },
              },
            ],
          },
          {
            id: "FAO4",
            name: messages.CountryAndCommodityStructure,
            paragraphs: [
              {
                id: "FAO41",
                type: "text",
                content: messages.FAOCountryAndCommodityStructureP1,
              },
              {
                id: "FAO42",
                type: "download",
                content: {
                  path: "/help-files/fao_oecd_data_mappings.xls",
                  text: "FAO-OECD Data Mappings.xlsx",
                },
              },
            ],
          },
          {
            id: "FAO5",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "FAO51",
                type: "text",
                content: messages.FAOReleaseScheduleP1,
              },
            ],
          },
          {
            id: "FAO6",
            name: messages.FormulasName,
            paragraphs: [
              {
                id: "FAO61",
                type: "download",
                content: {
                  path: "/help-files/formulas_oecd_fao.xlsx",
                  text: "Formulas OECD-FAO.xlsx",
                },
              },
            ],
          },
        ],
      },
      {
        id: "FAPRI",
        name: messages.FAPRIFullHeader,
        subsections: [
          {
            id: "FAPRI1",
            name: null,
            paragraphs: [
              {
                id: "FAPRI11",
                type: "link",
                content: {
                  path: "http://www.fapri.iastate.edu/outlook/2012/",
                  text: "http://www.fapri.iastate.edu/outlook/2012/",
                },
              },
            ],
          },
          {
            id: "FAPRI2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "FAPRI21",
                type: "text",
                content: messages.FAPRIOverviewP1,
              },
              {
                id: "FAPRI22",
                type: "download",
                content: {
                  path: "/help-files/fapri_assumptions.xls",
                  text: "FAPRI Assumptions.xls",
                },
              },
              {
                id: "FAPRI23",
                type: "text",
                content: messages.FAPRIOverviewP2,
              },
              {
                id: "FAPRI24",
                type: "list",
                content: [messages.FAPRIOverviewLi1, messages.FAPRIOverviewLi2, messages.FAPRIOverviewLi3],
              },
              {
                id: "FAPRI25",
                type: "text",
                content: messages.FAPRIOverviewP3,
              },
            ],
          },
          {
            id: "FAPRI3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "FAPRI31",
                type: "text",
                content: messages.FAPRIGlossaryOfAttributesP1,
              },
              {
                id: "FAPRI32",
                type: "download",
                content: {
                  path: "/help-files/fapri_glossary.xlsx",
                  text: "FAPRI Glossary.xlsx",
                },
              },
            ],
          },
          {
            id: "FAPRI4",
            name: messages.CountryAndCommodityStructure,
            paragraphs: [
              {
                id: "FAPRI41",
                type: "text",
                content: messages.FAPRICountryAndCommodityStructureP1,
              },
              {
                id: "FAPRI42",
                type: "download",
                content: {
                  path: "/help-files/fapri_data_mappings.xlsx",
                  text: "FAPRI Data Mappings.xlsx",
                },
              },
              {
                id: "FAPRI43",
                type: "text",
                content: messages.FAPRICountryAndCommodityStructureP2,
              },
            ],
          },
          {
            id: "FAPRI5",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "FAPRI51",
                type: "text",
                content: messages.FAPRIReleaseScheduleP1,
              },
            ],
          },
          {
            id: "FAPRI6",
            name: messages.FormulasName,
            paragraphs: [
              {
                id: "FAPRI61",
                type: "text",
                content: messages.FAPRIFormulasP1,
              },
              {
                id: "FAPRI62",
                type: "download",
                content: {
                  path: "/help-files/formulas_fapri.xlsx",
                  text: "Formulas FAPRI.xlsx",
                },
              },
            ],
          },
        ],
      },
      {
        id: "USDACrop",
        name: messages.USDACropFullHeader,
        subsections: [
          {
            id: "USDACrop1",
            name: null,
            paragraphs: [
              {
                id: "USDACrop11",
                type: "text",
                content: messages.USDACropSubtitle1,
              },
              {
                id: "USDACrop12",
                type: "link",
                content: {
                  path: "http://usda.mannlib.cornell.edu/MannUsda/viewStaticPage.do?url=http://usda.mannlib.cornell.edu/usda/ers/94005/./2014/index.html",
                  text: "http://usda.mannlib.cornell.edu/MannUsda/viewStaticPage.do?url=http://usda.mannlib.cornell.edu/usda/ers/94005/./2014/index.html",
                },
              },
              {
                id: "USDACrop13",
                type: "text",
                content: messages.USDACropSubtitle2,
              },
              {
                id: "USDACrop14",
                type: "link",
                content: {
                  path: "http://www.ers.usda.gov/data-products/international-baseline-data.aspx#.U-nSx_mSzzI",
                  text: "http://www.ers.usda.gov/data-products/international-baseline-data.aspx#.U-nSx_mSzzI",
                },
              },
            ],
          },
          {
            id: "USDACrop2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "USDACrop21",
                type: "text",
                content: messages.USDACropOverviewP1,
              },
              {
                id: "USDACrop22",
                type: "link",
                content: {
                  path: "http://www.ers.usda.gov/publications/oce-usda-agricultural-projections/oce141.aspx#.VBmmdPmSwpU",
                  text: "http://www.ers.usda.gov/publications/oce-usda-agricultural-projections/oce141.aspx#.VBmmdPmSwpU",
                },
              },
              {
                id: "USDACrop23",
                type: "text",
                content: messages.USDACropOverviewP2,
              },
              {
                id: "USDACrop24",
                type: "list",
                content: [messages.USDACropOverviewLi1, messages.USDACropOverviewLi2, messages.USDACropOverviewLi3],
              },
            ],
          },
          {
            id: "USDACrop3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "USDACrop31",
                type: "text",
                content: messages.USDACropGlossaryOfAttributesP1,
              },
              {
                id: "USDACrop32",
                type: "download",
                content: {
                  path: "/help-files/usda_forecasts_glossary.xlsx",
                  text: "USDA Forecast Glossary.xlsx",
                },
              },
            ],
          },
          {
            id: "USDACrop4",
            name: messages.CountryAndCommodityStructure,
            paragraphs: [
              {
                id: "USDACrop41",
                type: "text",
                content: messages.USDACropCountryandCommodityStructureP1,
              },
              {
                id: "USDACrop42",
                type: "download",
                content: {
                  path: "/help-files/usda_forecast_data_mappings.xls",
                  text: "USDA Forecast Data Mappings.xls",
                },
              },
            ],
          },
          {
            id: "USDACrop5",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "USDACrop51",
                type: "text",
                content: messages.USDACropReleaseScheduleP1,
              },
            ],
          },
          {
            id: "USDACrop6",
            name: messages.FormulasName,
            paragraphs: [
              {
                id: "USDACrop61",
                type: "text",
                content: messages.USDACropFormulasP1,
              },
              {
                id: "USDACrop62",
                type: "download",
                content: {
                  path: "/help-files/formulas_usda_forecasts.xlsx",
                  text: "Formulas USDA Forecasts.xlsx",
                },
              },
            ],
          },
        ],
      },
      {
        id: "DailyNASDAQ",
        name: messages.DailyNASDAQ,
        subsections: [
          {
            id: "DailyNASDAQ0",
            name: null,
            paragraphs: [
              {
                id: "USDA61",
                type: "table",
                content: {
                  headers: [messages.DailyNASDAQCommodityColumnTitle, messages.DailyNASDAQLinkColumnTitle],
                  rows: [
                    {
                      column1: messages.Soybean,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/zs",
                            text: "https://www.nasdaq.com/market-activity/commodities/zs",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.Wheat,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/zw",
                            text: "https://www.nasdaq.com/market-activity/commodities/zw",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.Corn,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/zc",
                            text: "https://www.nasdaq.com/market-activity/commodities/zc",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.Cocoa,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/cj:nmx",
                            text: "https://www.nasdaq.com/market-activity/commodities/cj:nmx",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.Coffee,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/kt:nmx",
                            text: "https://www.nasdaq.com/market-activity/commodities/kt:nmx",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.Oat,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/zo",
                            text: "https://www.nasdaq.com/market-activity/commodities/zo",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.RedWheat,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/ke",
                            text: "https://www.nasdaq.com/market-activity/commodities/ke",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.Rice,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/zr",
                            text: "https://www.nasdaq.com/market-activity/commodities/zr",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.SoybeanOil,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/zl",
                            text: "https://www.nasdaq.com/market-activity/commodities/zl",
                          },
                        ],
                      },
                    },
                    {
                      column1: messages.SoybeanMeal,
                      column2: {
                        type: "link",
                        content: [
                          {
                            path: "https://www.nasdaq.com/market-activity/commodities/zm",
                            text: "https://www.nasdaq.com/market-activity/commodities/zm",
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          },
          {
            id: "DailyNASDAQ1",
            name: messages.Overview,
            paragraphs: [
              {
                id: "DailyNASDAQ11",
                type: "text",
                content: messages.DailyNASDAQOverviewP1,
              },
            ],
          },
          {
            id: "DailyNASDAQ2",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "FAPRI31",
                type: "text",
                content: messages.DailyNASDAQGlossaryOfAttributesP2,
              },
            ],
          },
          {
            id: "DailyNASDAQ3",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "FAPRI41",
                type: "text",
                content: messages.DailyNASDAQReleaseScheduleP3,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "Prices",
    name: messages.Prices,
    sections: [
      {
        id: "APPrices",
        name: messages.APPrices,
        subsections: [
          {
            id: "APPrices1",
            name: messages.Overview,
            paragraphs: [
              {
                id: "APPrices11",
                type: "text",
                content: messages.APPricesOverviewP1,
              },
            ],
          },
          {
            id: "APPrices2",
            name: messages.DatasetStructure,
            paragraphs: [
              {
                id: "APPrices21",
                type: "text",
                content: messages.APPricesDatasetStructureP1,
              },
              {
                id: "APPrices22",
                type: "text",
                content: messages.APPricesDatasetStructureP2,
              },
              {
                id: "APPrices23",
                type: "download",
                content: {
                  path: "/help-files/definition_of_sources_for_ap_official_absolute_prices_and_price_indices_datasets.xlsx",
                  text: "Definition of sources for AP official Absolute Prices and Price Indices Datasets.xlsx",
                },
              },
              {
                id: "APPrices24",
                type: "title",
                content: messages.APPricesFieldCropsH,
              },
            ],
          },
          {
            id: "APPrices3",
            name: messages.USDAAMSMarketNews,
            paragraphs: [
              {
                id: "APPrices31",
                type: "link",
                content: {
                  path: "http://www.ams.usda.gov/AMSv1.0/ams.fetchTemplateData.do?template=TemplateA&amp;navID=MarketNewsAndTransportationData&amp;leftNav=MarketNewsAndTransportationData&amp;page=MarketNewsAndTransportationData&amp;acct=AMSPW",
                  text: "http://www.ams.usda.gov/",
                },
              },
              {
                id: "APPrices32",
                type: "text",
                content: messages.USDAAMSMarketNewsP1,
              },
              {
                id: "APPrices33",
                type: "text",
                content: messages.USDAAMSMarketNewsP2,
              },
            ],
          },
          {
            id: "APPrices4",
            name: messages.APPricesUSDAGAINH,
            paragraphs: [
              {
                id: "APPrices41",
                type: "link",
                content: {
                  path: "http://gain.fas.usda.gov/Pages/Default.aspx",
                  text: "http://gain.fas.usda.gov",
                },
              },
              {
                id: "APPrices42",
                type: "text",
                content: messages.APPricesUSDAGAINP1,
              },
              {
                id: "APPrices43",
                type: "text",
                content: messages.APPricesUSDAGAINP2,
              },
            ],
          },
          {
            id: "APPrices5",
            name: messages.APPricesICEH,
            paragraphs: [
              {
                id: "APPrices51",
                type: "link",
                content: {
                  path: "https://www.theice.com/homepage.jhtml",
                  text: "https://www.theice.com/",
                },
              },
              {
                id: "APPrices52",
                type: "text",
                content: messages.APPricesICEP1,
              },
            ],
          },
          {
            id: "APPrices6",
            name: messages.APPricesNYSEH,
            paragraphs: [
              {
                id: "APPrices61",
                type: "link",
                content: {
                  path: "https://globalderivatives.nyx.com/en/nyse-liffe",
                  text: "https://globalderivatives.nyx.com/en/nyse-liffe",
                },
              },
              {
                id: "APPrices62",
                type: "text",
                content: messages.APPricesNYSEP1,
              },
              {
                id: "APPrices63",
                type: "text",
                content: messages.APPricesNYSEP2,
              },
              {
                id: "APPrices64",
                type: "title",
                content: messages.APPricesFertilizerPricesH,
              },
            ],
          },
          {
            id: "APPrices7",
            name: messages.USDAAMSMarketNews,
            paragraphs: [
              {
                id: "APPrices71",
                type: "link",
                content: {
                  path: "http://www.ams.usda.gov/AMSv1.0/ams.fetchTemplateData.do?template=TemplateA&amp;navID=MarketNewsAndTransportationData&amp;leftNav=MarketNewsAndTransportationData&amp;page=MarketNewsAndTransportationData&amp;acct=AMSPW",
                  text: "http://www.ams.usda.gov/",
                },
              },
              {
                id: "APPrices72",
                type: "text",
                content: messages.USDAAMSMarketNewsP1,
              },
              {
                id: "APPrices73",
                type: "text",
                content: messages.APPricesFertilizerUSDAAMSP2,
              },
            ],
          },
          {
            id: "APPrices8",
            name: messages.APPricesFertilizerWorldBankH,
            paragraphs: [
              {
                id: "APPrices81",
                type: "link",
                content: {
                  path: "http://econ.worldbank.org/WBSITE/EXTERNAL/EXTDEC/EXTDECPROSPECTS/0,,contentMDK:21574907~menuPK:7859231~pagePK:64165401~piPK:64165026~theSitePK:476883,00.html",
                  text: "http://econ.worldbank.org/",
                },
              },
              {
                id: "APPrices82",
                type: "text",
                content: messages.APPricesFertilizerWorldBankP1,
              },
              {
                id: "APPrices83",
                type: "text",
                content: messages.APPricesFertilizerWorldBankP2,
              },
            ],
          },
        ],
      },
      {
        id: "APForecast",
        name: messages.APForecast,
        subsections: [
          {
            id: "APForecast1",
            name: messages.Overview,
            paragraphs: [
              {
                id: "APForecast11",
                type: "text",
                content: messages.APForecastOverviewP1,
              },
            ],
          },
          {
            id: "APForecast2",
            name: messages.DatasetStructure,
            paragraphs: [
              {
                id: "APForecast21",
                type: "text",
                content: messages.APForecastDatasetStructureP1,
              },
              {
                id: "APForecast22",
                type: "text",
                content: messages.APForecastDatasetStructureP2,
              },
              {
                id: "APForecast23",
                type: "download",
                content: {
                  path: "/help-files/definition_of_sources_for_ap_official_forecast_prices_dataset.xlsx",
                  text: "Definition of sources for AP official Forecast Prices Datasets.xlsx",
                },
              },
              {
                id: "APForecast24",
                type: "Text",
                content: messages.APForecastDatasetStructureP3,
              },
              {
                id: "APForecast25",
                type: "link",
                content: {
                  path: "http://usda.mannlib.cornell.edu/",
                  text: "http://usda.mannlib.cornell.edu",
                },
              },
              {
                id: "APForecast26",
                type: "text",
                content: messages.APForecastDatasetStructureP4,
              },
              {
                id: "APForecast27",
                type: "text",
                content: messages.APForecastDatasetStructureP5,
              },
              {
                id: "APForecast28",
                type: "link",
                content: {
                  path: "http://www.fapri.iastate.edu/outlook/",
                  text: "http://www.fapri.iastate.edu/outlook/",
                },
              },
              {
                id: "APForecast29",
                type: "text",
                content: messages.APForecastDatasetStructureP6,
              },
              {
                id: "APForecast210",
                type: "text",
                content: messages.APForecastDatasetStructureP7,
              },
              {
                id: "APForecast211",
                type: "link",
                content: {
                  path: "http://econ.worldbank.org/",
                  text: "http://econ.worldbank.org/",
                },
              },
              {
                id: "APForecast212",
                type: "text",
                content: messages.APForecastDatasetStructureP8,
              },
              {
                id: "APForecast213",
                type: "text",
                content: messages.APForecastDatasetStructureP9,
              },
              {
                id: "APForecast214",
                type: "link",
                content: {
                  path: "http://stats.oecd.org/",
                  text: "http://stats.oecd.org/",
                },
              },
              {
                id: "APForecast215",
                type: "text",
                content: messages.APForecastDatasetStructureP10,
              },
            ],
          },
        ],
      },
      {
        id: "AlternativePrice",
        name: messages.AlternativePrice,
        subsections: [
          {
            id: "AlternativePrice1",
            name: messages.Overview,
            paragraphs: [
              {
                id: "AlternativePrice11",
                type: "text",
                content: messages.AlternativePriceOverviewP1,
              },
            ],
          },
          {
            id: "AlternativePriceCbot1",
            name: messages.AlternativePriceCbotH,
            paragraphs: [
              {
                id: "AlternativePriceCbot11",
                type: "link",
                content: {
                  path: "http://www.cmegroup.com/trading/agricultural/#grainsAndOilseeds",
                  text: "http://www.cmegroup.com/trading/agricultural/#grainsAndOilseeds",
                },
              },
            ],
          },
          {
            id: "AlternativePriceCbot2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "AlternativePriceCbot21",
                type: "text",
                content: messages.AlternativePriceCbotOverview,
              },
            ],
          },
          {
            id: "AlternativePriceCbot3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "AlternativePriceCbot31",
                type: "text",
                content: messages.AlternativePriceCbotGlossaryP1,
              },
              {
                id: "AlternativePriceCbot31",
                type: "text",
                content: messages.AlternativePriceCbotGlossaryP2,
              },
            ],
          },
          {
            id: "AlternativePriceCbot4",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "AlternativePriceCbot41",
                type: "text",
                content: messages.AlternativePriceCbotReleaseP1,
              },
            ],
          },
          {
            id: "AlternativePriceCft1",
            name: messages.AlternativePriceCftH,
            paragraphs: [
              {
                id: "AlternativePriceCft11",
                type: "link",
                content: {
                  path: "http://www.cftc.gov/MarketReports/CommitmentsofTraders/HistoricalCompressed/index.htm",
                  text: "http://www.cftc.gov/MarketReports/CommitmentsofTraders/HistoricalCompressed/index.htm",
                },
              },
            ],
          },
          {
            id: "AlternativePriceCft2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "AlternativePriceCft21",
                type: "text",
                content: messages.AlternativePriceCftOverviewP1,
              },
              {
                id: "AlternativePriceCft22",
                type: "text",
                content: messages.AlternativePriceCftOverviewP2,
              },
              {
                id: "AlternativePriceCft23",
                type: "text",
                content: messages.AlternativePriceCftOverviewP3,
              },
            ],
          },
          {
            id: "AlternativePriceCft3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "AlternativePriceCft31",
                type: "text",
                content: messages.AlternativePriceCftGlossaryP1,
              },
              {
                id: "AlternativePriceCft32",
                type: "text",
                content: messages.AlternativePriceCftGlossaryP2,
              },
              {
                id: "AlternativePriceCft33",
                type: "text",
                content: messages.AlternativePriceCftGlossaryP3,
              },
              {
                id: "AlternativePriceCft34",
                type: "text",
                content: messages.AlternativePriceCftGlossaryP4,
              },
              {
                id: "AlternativePriceCft35",
                type: "text",
                content: messages.AlternativePriceCftGlossaryP5,
              },
            ],
          },
          {
            id: "AlternativePriceCft4",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "AlternativePriceCft41",
                type: "text",
                content: messages.AlternativePriceCftReleaseP1,
              },
            ],
          },
          {
            id: "AlternativePrice2",
            name: messages.AlternativePriceIMFPrimaryH,
            paragraphs: [
              {
                id: "AlternativePrice21",
                type: "link",
                content: {
                  path: "http://www.imf.org/external/np/res/commod/index.asp",
                  text: "http://www.imf.org/external/np/res/commod/index.asp",
                },
              },
              {
                id: "AlternativePrice22",
                type: "list",
                content: [messages.AlternativePriceIMFPrimaryLi1, messages.AlternativePriceIMFPrimaryLi2],
              },
              {
                id: "AlternativePrice23",
                type: "text",
                content: messages.AlternativePriceIMFPrimaryP1,
              },
            ],
          },
          {
            id: "AlternativePrice3",
            name: messages.AlternativePriceFAOIntH,
            paragraphs: [
              {
                id: "AlternativePrice31",
                type: "link",
                content: {
                  path: "http://www.fao.org/giews/pricetool/",
                  text: "http://www.fao.org/giews/pricetool/",
                },
              },
              {
                id: "AlternativePrice32",
                type: "list",
                content: [messages.AlternativePriceFAOIntLi1, messages.AlternativePriceFAOIntLi2],
              },
            ],
          },
          {
            id: "AlternativePrice4",
            name: messages.AlternativePriceUSFarmH,
            paragraphs: [
              {
                id: "AlternativePrice41",
                type: "link",
                content: {
                  path: "http://www.ers.usda.gov/data-products/fertilizer-use-and-price.aspx",
                  text: "http://www.ers.usda.gov/data-products/fertilizer-use-and-price.aspx",
                },
              },
              {
                id: "AlternativePrice42",
                type: "list",
                content: [messages.AlternativePriceUSFarmLi1, messages.AlternativePriceUSFarmLi2],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "Trade",
    name: messages.Trade,
    sections: [
      {
        id: "APTrade",
        name: messages.APTradeFullHeader,
        subsections: [
          {
            id: "APTrade1",
            name: null,
            paragraphs: [
              {
                id: "APTrade11",
                type: "link",
                content: {
                  path: "http://comtrade.un.org/db/dqBasicQuery.aspx",
                  text: "http://comtrade.un.org/db/dqBasicQuery.aspx",
                },
              },
              {
                id: "APTrade12",
                type: "text",
                content: messages.APTradeP1,
              },
              {
                id: "APTrade13",
                type: "list",
                content: [
                  messages.APTradeLi1,
                  messages.APTradeLi2,
                  messages.APTradeLi3,
                  messages.APTradeLi4,
                  messages.APTradeLi5,
                  messages.APTradeLi6,
                ],
              },
              {
                id: "APTrade15",
                type: "text",
                content: messages.APTradeP2,
              },
            ],
          },
          {
            id: "APTrade2",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "APTrade21",
                type: "text",
                content: messages.APTradeGlossaryOfAttributesP1,
              },
              {
                id: "APTrade22",
                type: "download",
                content: {
                  path: "/help-files/un_comtrade_glossary.xlsx",
                  text: "UN COMTRADE Glossary.xlsx",
                },
              },
            ],
          },
          {
            id: "APTrade3",
            name: messages.CountryAndCommodityStructure,
            paragraphs: [
              {
                id: "APTrade31",
                type: "text",
                content: messages.APTradeCountryandCommodityStructureP1,
              },
              {
                id: "APTrade32",
                type: "download",
                content: {
                  path: "/help-files/definition_of_sources_for_ap_official_trade_flow_dataset.xlsx",
                  text: "Definition of sources for AP official trade flow dataset.xlsx",
                },
              },
            ],
          },
          {
            id: "APTrade4",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "APTrade41",
                type: "text",
                content: messages.APTradeReleaseScheduleP1,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "MacroeconomyContainer",
    name: messages.Macroeconomy,
    sections: [
      {
        id: "Macroeconomy",
        name: messages.MacroeconomyGdpDataH,
        subsections: [
          {
            id: "Macroeconomy1",
            name: null,
            paragraphs: [
              {
                id: "Macroeconomy11",
                type: "link",
                content: {
                  path: "http://www.ers.usda.gov/data-products/international-macroeconomic-data-set/",
                  text: "http://www.ers.usda.gov/data-products/international-macroeconomic-data-set/",
                },
              },
            ],
          },
          {
            id: "Macroeconomy2",
            name: messages.Overview,
            paragraphs: [
              {
                id: "Macroeconomy21",
                type: "text",
                content: messages.MacroeconomyOverviewP1,
              },
            ],
          },
          {
            id: "Macroeconomy3",
            name: messages.GlossaryOfAttributes,
            paragraphs: [
              {
                id: "Macroeconomy31",
                type: "text",
                content: messages.MacroeconomyGlossaryP1,
              },
              {
                id: "Macroeconomy32",
                type: "text",
                content: messages.MacroeconomyGlossaryP2,
              },
            ],
          },
          {
            id: "Macroeconomy4",
            name: messages.ReleaseSchedule,
            paragraphs: [
              {
                id: "Macroeconomy41",
                type: "text",
                content: messages.MacroeconomyReleaseP1,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "SpecialTopicsContainer",
    name: messages.SpecialTopicsFullHeader,
    sections: [
      {
        id: "SpecialTopics",
        name: messages.SpecialTopicsFullHeader,
        subsections: [
          {
            id: "SpecialTopics1",
            name: messages.SpecialTopicsConversionH,
            paragraphs: [
              {
                id: "SpecialTopics11",
                type: "text",
                content: messages.SpecialTopicsConversionP1,
              },
              {
                id: "SpecialTopics12",
                type: "text",
                content: messages.SpecialTopicsConversionP2,
              },
              {
                id: "SpecialTopics13",
                type: "download",
                content: {
                  path: "/help-files/conversions_of_units.xls",
                  text: "Conversions of Units.xls",
                },
              },
            ],
          },
        ],
      },
    ],
  },
];
